import Link from "next/link"
import styles from './ua.module.scss'
import Button from "../button/Button"

export default function Pill(props) {

  const theme = () => {
    if (!props.theme || props.plain || props.theme == "none") return ""
    let s = [ styles.pill ]
    if (Array.isArray(props.theme)) {
      props.theme.map(t => {
        s.push(styles[t])
      })
    } else {
      s.push(styles[props.theme])
    }
    return s.join(" ")
  }
  
  if (props.link) {
    return (
      <Link href={props.link} className={styles.pill} prefetch={false}>
        { props.childrent || props.label }
      </Link>
    )
  } else {
    return (
      <div className={theme()} label={props.label}>
        { props.children || props.label }
      </div>
    )
  }
  
}